import type { PartSvgProps } from './types'

export default function MuzzleDeviceSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 80,
  height = 80
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 80 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Main body cylinder */}
      <rect x="10" y="24" width="60" height="32" rx="5"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Vent slot 1 */}
      <rect x="20" y="30" width="12" height="5" rx="1"
            fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Vent slot 2 */}
      <rect x="20" y="38" width="12" height="5" rx="1"
            fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Vent slot 3 */}
      <rect x="20" y="46" width="12" height="5" rx="1"
            fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Thread shoulder / rear lip */}
      <rect x="58" y="20" width="12" height="40" rx="3"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Muzzle opening */}
      <circle cx="14" cy="40" r="6" fill="none" stroke={stroke} strokeWidth="1.5" />
    </svg>
  )
}
